var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ac-collection-tableone',{attrs:{"rows":_vm.rows,"checkbox":_vm.checkbox,"number":_vm.number}})}
var staticRenderFns = []

export { render, staticRenderFns }